<template>
    <div>
        <router-view />
    </div>
</template>

<script>
export default {
    layout:"kb",
    auth: false,
    beforeCreate(){
      if (this.$route.path.split("/").filter(Boolean).length == 3)
        this.$router.push({path: `/kb/articles/${this.$route.params.id}/slug`});
    }
};
</script>
